import { supabase, supabaseConfigured } from "./supabaseClient";
import { translate } from "@/i18n/I18nProvider";

/**
 * Guarda o pedido do simulador na Supabase (histórico + dados do jogador).
 * @param {{
 *   userId: string;
 *   player: { discordUserId?: string | null; discordUsername?: string | null; discordGlobalName?: string | null; discordTag?: string; discordAvatarUrl?: string | null; steamId: string };
 *   invoice: { name: string; budget: number; total: number; kitTotal?: number; benefitsExtra?: number; benefits?: unknown[]; items?: unknown[] };
 * }} params
 */
export async function saveVipSimulatorRequest({ userId, player, invoice }) {
    if (!supabaseConfigured || !supabase) {
        return { ok: false, error: translate("simulator.persist.notConfigured") };
    }

    const row = {
        user_id: userId,
        vip_name: invoice.name?.trim() || "VIP",
        discord_user_id: player.discordUserId ?? null,
        discord_username: player.discordUsername ?? null,
        discord_global_name: player.discordGlobalName ?? null,
        discord_tag: player.discordTag ?? null,
        discord_avatar_url: player.discordAvatarUrl ?? null,
        steam_id: player.steamId,
        budget: Number(invoice.budget) || 0,
        total_estimated: Number(invoice.total) || 0,
        kit_total: Number(invoice.kitTotal ?? invoice.total) || 0,
        benefits_extra: Number(invoice.benefitsExtra) || 0,
        payload: {
            benefits: invoice.benefits ?? [],
            items: invoice.items ?? [],
        },
    };

    const { error } = await supabase.from("vip_simulator_requests").insert(row);

    if (error) {
        console.warn("[vipSimulatorPersist]", error);
        return { ok: false, error: error.message };
    }

    return { ok: true };
}
